<div class="inquirement text-primary mrb-15">
    <a [routerLink]="['/account/consultation', consultationId]" class="weight-600 pse-10 pb-25 pt-30">{{ content }}</a>
    <div class="d-flex justify-content-between mrt-20 pse-10 pb-15 border-bottom">
        <div class="ques-data size-2">{{ createdAt | date : 'd/M/yyyy' }}</div>
        <div class="d-flex justify-content-between">
            <!-- <div class="cursor-pointer comments d-flex align-items-center mre-15 mrt-1">
                <div class="mre-4">4</div>
                <img class="w-100 max-20" src="../../../../assets/images/Iconmaterial-comment.svg" alt="icon">
            </div>-->
            <div class="delete cursor-pointer" (click)="deleteConsultation(consultationId)"><img
                    src="../../../../assets/images/Iconmaterial-delete.svg" alt="icon"></div>
        </div>
    </div>
  </div>
